// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import { Theme } from '@mui/material/styles';

const styles = (theme: Theme) => ({
  wrapper: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(2),
  },
  content: {
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'center',
    gap: theme.spacing(2),
    maxWidth: theme.spacing(60),
    width: '100%',
  },
  actions: {
    display: 'flex',
    gap: theme.spacing(1.5),
  },
  actionButton: {
    textTransform: 'none' as const,
  },
});

export default styles;
